import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_tokefrio-launch/artifacts/82hhhvkm_image.png";
const WHATSAPP_NUMBER = "5565992258000";
const WHATSAPP_MESSAGE = "Olá! Gostaria de solicitar um orçamento para climatização.";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Sobre', href: '#sobre' },
    { label: 'Serviços', href: '#servicos' },
    { label: 'Portfólio', href: '#portfolio' },
    { label: 'Orçamento', href: '#orcamento' },
    { label: 'Contato', href: '#contato' },
  ];

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`, '_blank');
  };

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-sm border-b border-slate-100`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex-shrink-0" data-testid="header-logo-link">
            <img
              src={LOGO_URL}
              alt="Tokefrio Climatização"
              className="h-16 lg:h-20 object-contain"
              data-testid="header-logo"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="nav-link font-manrope text-sm font-medium text-slate-600 hover:text-sky-600 transition-colors"
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden md:flex items-center gap-4">
            <Button
              onClick={handleWhatsApp}
              className="bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-full px-6 py-2.5 transition-all btn-primary"
              data-testid="header-cta-button"
            >
              <Phone className="w-4 h-4 mr-2" />
              Solicitar Orçamento
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-slate-600 hover:text-sky-600 transition-colors"
            data-testid="mobile-menu-button"
            aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mobile-menu-enter border-t border-slate-100" data-testid="mobile-menu">
            <nav className="py-4 space-y-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="block px-4 py-3 font-manrope text-sm font-medium text-slate-600 hover:text-sky-600 hover:bg-slate-50 rounded-xl transition-all"
                  data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </a>
              ))}
              <div className="px-4 pt-4">
                <Button
                  onClick={handleWhatsApp}
                  className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-full py-3 transition-all"
                  data-testid="mobile-cta-button"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Solicitar Orçamento
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
